module.exports = __webpack_public_path__ + "img/social-base.1c57ef87.svg";